/** Build-time configuration (Vite env). */
export const env = {
  chainId: Number(import.meta.env.VITE_CHAIN_ID ?? 4663),
  walletConnectProjectId: (import.meta.env.VITE_WALLETCONNECT_PROJECT_ID as string | undefined) || undefined,
  dev: import.meta.env.DEV,
}
